import { useMutation } from '@apollo/client';

import PROGRAM_JOIN_MUTATION from '../queries/ProgramJoin.graphql';
import type {
  ProgramMembership_JoinMutation,
  ProgramMembership_JoinMutationVariables,
} from '../queries/__generated__/ProgramJoin';

export function useProgramJoinMutation() {
  const [joinProgram] = useMutation<ProgramMembership_JoinMutation, ProgramMembership_JoinMutationVariables>(
    PROGRAM_JOIN_MUTATION,
    {
      context: { clientName: 'gatewayGql' },
    }
  );

  const programJoinMutation = async (input: ProgramMembership_JoinMutationVariables['input']) => {
    try {
      const response = await joinProgram({
        variables: { input },
      });

      if (response.data?.ProgramMembership_Join.__typename === 'ProgramMembership_JoinResultFailure') {
        throw new Error(response.data.ProgramMembership_Join.error);
      }

      return response.data?.ProgramMembership_Join;
    } catch (e) {
      throw e;
    }
  };

  return {
    programJoinMutation,
  };
}
